// Tiny client-side cache for the blog feed.
// Dedupes fetches across pages and enables hover-prefetch,
// so opening a post from a card feels instant.

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Prerender bootstrap: build-time prerendered pages embed the exact data they
// were rendered with, so the first client render matches the static HTML
// (clean hydration, no skeleton flash). Components still revalidate through
// getPosts()/getPost() after mount, so data never goes stale beyond a session.
const BOOT =
  typeof window !== "undefined" && window.__RIHAI_BOOTSTRAP__
    ? window.__RIHAI_BOOTSTRAP__
    : null;

export function getBootPosts() {
  return BOOT && Array.isArray(BOOT.posts) && BOOT.posts.length ? BOOT.posts : null;
}

export function getBootPost(slug) {
  return BOOT && BOOT.post && BOOT.slug === slug ? BOOT.post : null;
}

let postsPromise = null;
const postBySlug = new Map();

// Seed the per-slug cache with the bootstrap post so the first getPost() call
// on a prerendered article page resolves instantly.
if (BOOT && BOOT.post && BOOT.slug) {
  postBySlug.set(BOOT.slug, Promise.resolve(BOOT.post));
}

export function getPosts() {
  if (!postsPromise) {
    postsPromise = fetch(`${BACKEND}/api/blog/posts`)
      .then((r) => (r.ok ? r.json() : []))
      .catch(() => []);
  }
  return postsPromise;
}

export function getPost(slug) {
  if (!postBySlug.has(slug)) {
    const p = fetch(`${BACKEND}/api/blog/posts/${slug}`).then((r) => {
      if (!r.ok) {
        const err = new Error("post fetch failed");
        err.status = r.status;
        throw err;
      }
      return r.json();
    });
    // Don't cache failures forever — allow a retry on next visit
    p.catch(() => postBySlug.delete(slug));
    postBySlug.set(slug, p);
  }
  return postBySlug.get(slug);
}

// Fire-and-forget warm-up (e.g. on card hover)
export function prefetchPost(slug) {
  getPost(slug).catch(() => {});
}
